<template>
  <div class="main-box">
    <!-- 调用接口 -->
    <!-- <el-row :gutter="12"> -->
    <!-- <el-col :span="4"> -->
    <div
      class="grid_box"
      v-for="item in studentListArray"
      :key="item.id"
      @click="answer(item)"
    >
      <img src="@/assets/head.jpeg" alt />
      <span class="text_1">{{ item.name }}</span>
      <span class="text_2">
        {{ item.classInfo ? item.classInfo.classInfo : '无班级' }}
      </span>
      <div class="icons">
        <!-- <span><i class="el-icon-user"></i></span> -->
      </div>
      <div class="del-backColor"></div>
      <el-button
        class="del-btn"
        icon="el-icon-remove"
        circle
        @click.stop="deleteStudentClick(item.id)"
      ></el-button>
    </div>
    <el-dialog :visible.sync="dialogShow" :before-close="cancleClick" center>
      <div class="beginTesting">
        <el-button type="text" @click="homeShow">量表测试</el-button>
        <el-button type="text" @click="obstacleShow"
          >修订学龄儿童语言障碍评量表</el-button
        >
        <el-button
          type="text"
          v-for="item in scaleList"
          :key="item.id"
          @click="scaleJump(item.id)"
        >
          {{ item.name }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { deleteStudent } from '@/api/student/index.js';
import { Dict as API } from '@/views/topic-list/api';

export default {
  inject: ['reload'],
  props: {
    studentListArray: Array
  },
  data() {
    return {
      name: 'info',
      idx: '',
      dialogShow: false,
      rangeTime: '',
      studentIdA: '',
      form: {
        rangeTime: ''
      },
      rules: {
        rangeTime: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      scaleList: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const api = API.list;
      const { data } = await api();
      this.scaleList = data;
    },
    async deleteStudent(id) {
      console.log(id);
      let params = {
        ids: id
      };
      await deleteStudent(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('删除成功');
          this.reload();
        }
      });
    },
    deleteStudentClick(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteStudent(id);
      });
    },
    answer(value) {
      if (!value.birthday || !value.sex) {
        this.$message.error('缺少身份信息');
        this.$emit('updataStudent', value);
      } else {
        this.studentIdA = value.id;
        sessionStorage.setItem('studentIdA', this.studentIdA);

        this.dialogShow = true;
      }
    },
    homeShow() {
      this.$router.push({ name: 'homeShow' });
    },
    obstacleShow() {
      this.$router.push({ name: 'obstacleShow' });
    },
    cancleClick() {
      this.dialogShow = false;
    },
    beginBtn() {
      let dateTime = new Date().getTime();
      let dateTimeAll = new Date();
      let dateTimeAllShow =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      sessionStorage.setItem('dateTimeAllShow', dateTimeAllShow);
      sessionStorage.setItem('dateTime', dateTime);
    },
    //  量表跳转
    scaleJump(id) {
      this.$router.push({
        name: 'scaleContent',
        query: {
          id,
          studentId: this.studentIdA
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-row {
  margin-bottom: 20px;
}
::v-deep .el-col {
  border-radius: 4px;
}
.main-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 200px;
}
.grid_box {
  position: relative;
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: space-around;
  margin-right: 20px;
  margin-top: 20px;
  width: 185px;
  height: 200px;
  padding: 10px 0;
  background-color: #fcfbfc;
  border-radius: 8px;
  //
  img {
    border-radius: 50%;
    width: 71px;
    height: 71px;
  }
  .text_1 {
    color: #333333;
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    white-space: nowrap;
    line-height: 22px;
    cursor: pointer;
  }
  .text_2 {
    color: #c4c4c4;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    white-space: nowrap;
  }
  .icons {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 22px;
    i {
      cursor: pointer;
    }
  }
  .el-icon-aim::before {
    content: 'IEP';
    font-size: 18px;
    color: #546566;
  }
  .del-btn {
    display: none;
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 0;
    border: none;
    color: red;
    font-size: 22px;
  }
  &:hover {
    .del-btn {
      display: block;
    }
    .del-backColor {
      display: block;
    }
  }
  .del-backColor {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    opacity: 0.2;
    border-radius: 8px;
    background-color: aqua;
  }
}
.beginTesting {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .el-button {
    font-size: 20px !important;
  }
}
</style>